import { Button } from '@augmentt-dev/ui-components'
import clsx from 'clsx'
import PropTypes from 'prop-types'
import React from 'react'
import { Modal } from 'react-bootstrap'
import { FormattedMessage } from 'react-intl'
import ReadOnlyText from '../../../../components/ReadOnlyText'

const propTypes = {
  /**
   * If true, modal is shown.
   */
  show: PropTypes.bool,
  /**
   * Callback to hide the modal
   */
  onHide: PropTypes.func.isRequired,
  /**
   * The collection to be showed
   */
  collection: PropTypes.object.isRequired, // eslint-disable-line react/forbid-prop-types
  /**
   * callback to set the collection to be edited
   */
  onEditClick: PropTypes.func,
}

function ViewCollectionModal(props) {
  const { show = false, onHide, collection, onEditClick = null } = props ?? {}

  return (
    <Modal backdrop centered className={clsx({ in: show })} show={show} onHide={onHide}>
      <Modal.Header closeButton>
        <Modal.Title>
          <FormattedMessage id="COMPANIES.NAME_COLLECTION" values={{ name: collection.owner?.name }} />
        </Modal.Title>
      </Modal.Header>

      <Modal.Body className="unstyled-modal text-color-default">
        <ReadOnlyText title="GENERAL.PARENT_COMPANY" titleClassName="text-strong" value={collection?.owner?.name} />

        <ReadOnlyText
          title="MENU.COMPANIES"
          titleClassName="text-strong"
          value={collection?.members?.map((member) => member.name)}
        />
      </Modal.Body>

      <Modal.Footer className={clsx('d-flex', 'justify-content-between')}>
        <Button variant="secondary" onClick={onHide} id="view-collection-close-button" className="me-3">
          <FormattedMessage id="GENERAL.CLOSE" />
        </Button>

        {onEditClick && (
          <Button id="edit-collection-button" variant="primary" onClick={() => onEditClick(collection)}>
            <FormattedMessage id="GENERAL.EDIT" />
          </Button>
        )}
      </Modal.Footer>
    </Modal>
  )
}

ViewCollectionModal.propTypes = propTypes

export default ViewCollectionModal
